import { PermissionsUnionModel } from "client/Api/common";
import { UsersAndUserGroupsDataModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import {
	Checkbox,
	FormItem,
	ValidationError
} from "client/Components";
import { attachToUserAndUserGroupCollection } from "client/Features/Users/UserAndUserGroupCollection/attachable";
import { UserAndUserGroupCollection, UserAndUserGroupKind } from "client/Features/Users/UserAndUserGroupCollection/UserAndUserGroupCollection";
import { ActiveTab } from "client/Features/Users/UserAndUserGroupTabSelector/UserAndUserGroupTabSelector";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import styles from "./WhoHasAccessSection.module.less";

export type WhoHasAccessSectionProps = {
	attachable: IValueInputAttachable<PermissionsUnionModel>;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export const WhoHasAccessSection = (props: WhoHasAccessSectionProps): ReactElement => {
	const {
		attachable,
		usersAndUserGroupsData
	} = props;

	return (
		<div className={styles.root}>
			<FormItem>
				<Checkbox
					{...attachable.for("everyone").attachToCheckbox()}
					text={localize("_EveryoneHasAccess")}
				/>
				<ValidationError {...attachable.for("everyone").attachToValidationError()} />
			</FormItem>
			{attachable.when(
				x => !x.everyone,
				permissonsHandler => (
					<>
						<UserAndUserGroupCollection
							{...attachToUserAndUserGroupCollection(
								permissonsHandler.for("specificSet"),
								{
									kind: UserAndUserGroupKind.Edit,
									dialogTitleWhenAddingUsersAndUserGroups: localize("_AddGroupsOrUsers")
								}
							)}
							activeTab={ActiveTab.User}
							allUsersAndUserGroupsData={usersAndUserGroupsData}
						/>
						<ValidationError {...permissonsHandler.for("specificSet").attachToValidationError()} />
					</>
				)
			)}
		</div>
	);
};
WhoHasAccessSection.displayName = "WhoHasAccessSection";
